import React, {useState} from "react";

const AssignWorkerModal = ({ show, onClose, employees, onAssign }) => {
    const [selectedEmployees, setSelectedEmployees] = useState([]);

    const handleChange = (e) => {
        const { checked, value } = e.target;
        setSelectedEmployees((prev) =>
            checked ? [...prev, value] : prev.filter((id) => id !== value)
        );
    };

    const handleAssign = () => {
        onAssign(selectedEmployees);
        onClose();
    };
    if (!show) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg w-96">
                {/* Header */}
                <div className="bg-teal-400 text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
                    <h2 className="text-lg font-semibold">Assign Employees</h2>
                    <button onClick={onClose} className="text-white text-xl">&times;</button>
                </div>

                {/* Modal Body */}
                <div className="p-6">
                    <form>
                        {employees.map((employee) => (
                            <label key={employee.id} className="flex items-center space-x-3 mb-3">
                                <input
                                    type="checkbox"
                                    value={employee.id}
                                    onChange={handleChange}
                                    className="h-4 w-4 text-teal-500 border-gray-300 rounded"
                                />
                                <span className="text-gray-800">{employee.name}</span>
                            </label>
                        ))}
                    </form>
                </div>

                {/* Footer */}
                <div className="flex justify-end px-6 py-3 bg-gray-100 rounded-b-lg">
                    <button
                        onClick={onClose}
                        className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 transition mr-2"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleAssign}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
                    >
                        Assign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssignWorkerModal;
